export default __webpack_public_path__ + "static/canvas-09f7dcf05396dc3ee70c1ba688e6b0da.png";